import React, { useEffect, useState } from "react";
import { useAtlas } from "../../store/atlasStore";
import { Search, Activity } from "lucide-react";
import { API } from "../atlas/helpers";

const PROVIDERS = ["synthetic", "yahoo", "binance", "coingecko"];

function Clock() {
  const [t, setT] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setT(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="topbar-clock">
      {t.toISOString().slice(0,19).replace("T"," ")} UTC
    </span>
  );
}

export function Topbar() {
  const { state, dispatch, INTERVALS } = useAtlas();
  const { provider, symbol, interval, symbols, featureCount, systemStatus, workspace } = state;

  const symList = symbols[provider] || [];

  const handleProvider = (e) => {
    const p = e.target.value;
    const newSyms = state.symbols[p] || [];
    dispatch({ type: "SET_PROVIDER", payload: p });
    if (newSyms.length) dispatch({ type: "SET_SYMBOL", payload: newSyms[0].symbol });
  };

  const WORKSPACE_LABELS = {
    overview: "OVERVIEW", markets: "MARKETS", research: "RESEARCH",
    decision: "DECISION ENGINE", paper: "PAPER TRADING",
    models: "MODELS", features: "FEATURES", system: "SYSTEM",
  };

  return (
    <header className="atlas-topbar">
      {/* Logo */}
      <div className="topbar-logo">ATLAS</div>

      {/* Workspace Label */}
      <span style={{ fontSize: 10, fontWeight: 600, color: "var(--text-tertiary)", letterSpacing: "0.1em", textTransform: "uppercase", flexShrink: 0 }}>
        {WORKSPACE_LABELS[workspace] || workspace}
      </span>

      <div className="topbar-sep" />

      {/* Instrument Selector */}
      <div className="instrument-selector">
        <select
          className="inp"
          value={provider}
          onChange={handleProvider}
          style={{ width: 88 }}
        >
          {PROVIDERS.map(p => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>

        <select
          className="inp"
          value={symbol}
          onChange={e => dispatch({ type: "SET_SYMBOL", payload: e.target.value })}
          style={{ width: 120 }}
        >
          {symList.map(s => (
            <option key={s.symbol} value={s.symbol}>{s.symbol}</option>
          ))}
        </select>

        <select
          className="inp"
          value={interval}
          onChange={e => dispatch({ type: "SET_INTERVAL", payload: e.target.value })}
          style={{ width: 56 }}
        >
          {INTERVALS.map(i => (
            <option key={i} value={i}>{i}</option>
          ))}
        </select>
      </div>

      <div className="topbar-sep" />

      {/* System stats */}
      <div className="topbar-stat">
        <span className="ts-k">FEATS</span>
        <span className="ts-v">{featureCount ?? 827}</span>
      </div>

      <div className="topbar-sep" />

      {/* System status indicator */}
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <div className={`pulse-dot${systemStatus === "ok" ? "" : systemStatus === "warn" ? " amber" : " red"}`} />
        <span style={{ fontSize: 9, color: "var(--text-tertiary)", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 600 }}>
          {systemStatus === "ok" ? "Online" : systemStatus}
        </span>
      </div>

      {/* Command Palette trigger */}
      <button
        className="btn btn-ghost"
        style={{ marginLeft: 4, gap: 5, padding: "3px 8px" }}
        onClick={() => dispatch({ type: "OPEN_CMD" })}
      >
        <Search style={{ width: 11, height: 11 }} />
        <span style={{ fontSize: 10 }}>Search</span>
        <span className="cmd-key">Ctrl K</span>
      </button>

      <Clock />
    </header>
  );
}
